import { listIcon, scheduledIcon, workOrderIcon, regionsIcon,hospitalIcon, siteDepartmentIcon } from "assets/icons/svgIcons";
import { ClusterIcon,SubDepartmentIcon, MaintenanceDepartmentIcon } from "assets/icons";

export default [
  {
    id: "location",
    title: "Location",
    icon: workOrderIcon,
    type: "collapse",
    isActive: true,
    pageTitle: "Location",
    permissions: [
      "super_admin",
      "site_admin",
      "organization_admin",
    ],
    children: [
      {
          id: "regions",
          title: "Regions",
          icon: regionsIcon,
          pageTitle: "Regions List",
          navLink: "/regions",
          type: "item",
          permissions: ["super_admin", "site_admin", "organization_admin"],
        },
      {
          id: "cluster",
          title: "Cluster",
          icon: ClusterIcon,
          pageTitle: "Cluster",
          navLink: "/clusters",
          type: "item",
          permissions: [
            "super_admin",
            "site_admin",
            "organization_admin",
          ],
        },
      {
          id: "sites",
          title: "Sites",
          icon: hospitalIcon,
          pageTitle: "Sites List",
          navLink: "/sites",
          type: "item",
          permissions: ["super_admin"],
        },
      {
          id: "zones",
          title: "Zones",
          icon: hospitalIcon,
          pageTitle: "Zones List",
          navLink: "/zones",
          type: "item",
          permissions: ["super_admin"],
        },
      {
          id: "siteDepartments",
          title: "Site Departments",
          icon: siteDepartmentIcon,
          pageTitle: "Site Departments List",
          navLink: "/siteDepartments",
          type: "item",
          permissions: ["super_admin", "site_admin"],
        },
        {
        id: "maintenanceDepartment",
        title: "Maintenance Dept",
        icon: MaintenanceDepartmentIcon,
        pageTitle: "Maintenance Department",
        navLink: "/maintenanceDepartments",
        type: "item",
        permissions: [
            "super_admin",
            "site_admin",
            "organization_admin",
            "engineer",
            "hmc_admin",
            "hmc_supervisor",
            "hmc_technician",
            "qa",
            "helpdesk",
        ],
        },
        {
        id: "subDepartments",
        title: "Sub Departments",
        icon: SubDepartmentIcon,
        pageTitle: "Sub Departments",
        navLink: "/subDepartments",
        type: "item",
        permissions: [
            "super_admin",
            "site_admin",
            "organization_admin",
        ],
        },
    ],
  },
];
